import { NgModule } from '@angular/core';
import { MatDialogConfig, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { DialogService } from './dialog.service';

const defaultDialogConfig: MatDialogConfig = {
  ariaModal: true
};

@NgModule({
  imports: [MatDialogModule],
  providers: [DialogService, { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: defaultDialogConfig }]
})
export class DialogModule {
  constructor(private dialogService: DialogService) {
    dialogService.toggleOpenClassOnBodyListeners();
  }
}
